import * as BtnC from './_cccBtnC';
import * as GridC from './_cccGridC';
import * as _cr from './_cr';
import * as _hm from './_hm';
import * as _ht from './_ht';

import { useCfmz } from './_csMdlCfm';

export const N = (pz: {
  sPz: _ht.dz,
  abtz?: {
    gridBtnz?: _ht.dz,
    btnNextz?: _ht.dz,
    btnBackz?: _ht.dz,
  },
  cz: {
    tgt: _ht.s,
    onBackTop?: () => void,
    onBackCtt?: () => void,
    onCrtAsync?: (_sCfmz: _ht.dz) => _ht.b,
    onAddPrs?: () => void,
    onUdtAsync?: (_sCfmz: _ht.dz) => _ht.b,
    onDltAsync?: () => _ht.b,
    bfrClds?: _ht.ls,
    atrClds?: _ht.ls,
  },
  boxStlz: _ht.dz,
}) => {

  const _sCfmz = useCfmz();

  let _bOnPrs = false;

  return (
    _cr.c(GridC.N, {
      abtz: pz.abtz?.gridBtnz,
      boxStlz: pz.boxStlz,
      lineCs: [
        {
          cellCs: ([] as _ht.ls).concat(
            pz.cz.bfrClds,
            [

              pz.sPz.crt.steps[0] == 0 && pz.cz.onBackTop ?
              {
                boxClds: [

                  _cr.c(BtnC.N, {
                    abtz: pz.abtz?.btnBackz,
                    lblCz: {
                      text: `前の画面に戻る`,
                    },
                    frmCz: {
                      pslPtyz: {
                        onPrs: pz.cz.onBackTop
                      }
                    },
                  }),

                ]
              }
              : undefined,

              //pz.sPz.crt.steps[0] == 0 && pz.cz.onCrtAsync?
              pz.sPz.crt.steps[0] == 0 && (pz.cz.onCrtAsync || pz.cz.onAddPrs)?
              {
                boxClds: [

                  _cr.c(BtnC.N, {
                    abtz: pz.abtz?.btnNextz,
                    lblCz: {
                      text: `${pz.cz.tgt}を追加`,
                    },
                    frmCz: {
                      pslPtyz: {
                        onPrs: () => {
                          if (pz.cz.onAddPrs) {
                            pz.cz.onAddPrs();
                          }
                          else {
                            pz.sPz.set({
                              steps: [1],
                              phs: 'c',
                            })
                          }
                        }
                      }            
                    },
                  }),

                ]
              }
              : undefined,

              pz.sPz.crt.steps[0] == 1 && pz.sPz.crt.phs != 'u' ?
              {
                boxClds: [

                  _cr.c(BtnC.N, {
                    abtz: pz.abtz?.btnBackz,
                    lblCz: {
                      text: '前の画面に戻る',
                    },
                    frmCz: {
                      pslPtyz: {
                        onPrs: () => {
                          if (pz.cz.onBackCtt) {
                            pz.cz.onBackCtt();                          
                          }
                          else {
                            pz.sPz.set({
                              steps: [0],
                              phs: 'd',
                            })
                          }
                        }
                      }
                    },
                  }),
                ]
              }
              : undefined,

              pz.sPz.crt.steps[0] == 1 && pz.sPz.crt.phs == 'u' ?
              {
                boxClds: [

                  _cr.c(BtnC.N, {
                    abtz: pz.abtz?.btnBackz,
                    lblCz: {
                      text: `変更を止める`,
                    },
                    frmCz: {
                      pslPtyz: {
                        onPrs: () => {
                          pz.sPz.set({
                            steps: [1],
                            phs: 'd',
                          })
                        }
                      }            
                    },
                  }),
                ]
              }
              : undefined,

              pz.sPz.crt.steps[0] == 1 && pz.sPz.crt.phs == 'c' && pz.cz.onCrtAsync ?
              {
                boxClds: [

                  _cr.c(BtnC.N, {
                    abtz: pz.abtz?.btnNextz,
                    lblCz: {
                      text: `${pz.cz.tgt}を追加`,
                    },
                    frmCz: {
                      pslPtyz: {
/*
                        onPrs: async () => {
                          if (pz.cz.onCrtAsync) {
                            const _b = await pz.cz.onCrtAsync(_sCfmz);
                            if (_b != false) {
                              pz.sPz.set({
                                steps: [1],
                                phs: 'd',
                              })
                            }
                          }
                        },
*/
                        onPrs: async () => {
                          if (pz.cz.onCrtAsync && _bOnPrs == false) {
                            _bOnPrs = true;
                            const _b = await pz.cz.onCrtAsync(_sCfmz);
                            if (_b != false) {
                              pz.sPz.set({
                                steps: [1],
                                phs: 'd',
                              })
                            }
                            _bOnPrs = false;
                          }
                        },
                      }            
                    },
                  }),
                ]
              }
              : undefined,

              pz.sPz.crt.steps[0] == 1 && pz.sPz.crt.phs == 'd'?
              {
                boxClds: [

                  _cr.c(BtnC.N, {
                    abtz: pz.abtz?.btnNextz,
                    lblCz: {
                      text: `${pz.cz.tgt}を変更`,
                    },
                    frmCz: {
                      pslPtyz: {
                        onPrs: () => {
                          pz.sPz.set({
                            steps: [1],
                            phs: 'u',
                          })
                        }
                      }            
                    },
                  }),
                ]
              }
              : undefined,

              pz.sPz.crt.steps[0] == 1 && pz.sPz.crt.phs == 'u' && pz.cz.onUdtAsync?
              {
                boxClds: [

                  _cr.c(BtnC.N, {
                    abtz: pz.abtz?.btnNextz,
                    lblCz: {
                      text: '変更を保存',
                    },
                    frmCz: {
                      pslPtyz: {
/*
                        onPrs: async () => {
                          if (pz.cz.onUdtAsync) {                            
                            const _b = await pz.cz.onUdtAsync(_sCfmz);
                            if (_b != false) {
                              pz.sPz.set({
                                steps: [1],
                                phs: 'd',
                              })
                            }
                          }
                        },
*/
                        onPrs: async () => {
                          if (pz.cz.onUdtAsync && _bOnPrs == false) {                            
                            _bOnPrs = true;
                            const _b = await pz.cz.onUdtAsync(_sCfmz);
                            if (_b != false) {
                              pz.sPz.set({
                                steps: [1],
                                phs: 'd',
                              })
                            }
                            _bOnPrs = false;
                          }
                        },
                      }            
                    },
                  }),
                ]
              }
              : undefined,

              pz.sPz.crt.steps[0] == 1 && pz.sPz.crt.phs == 'd' && pz.cz.onDltAsync ?
              {
                boxClds: [

                  _cr.c(BtnC.N, {
                    abtz: pz.abtz?.btnBackz,
                    lblCz: {
                      text: `${pz.cz.tgt}を削除`,
                    },
                    frmCz: {
                      pslPtyz: {
                        onPrs: () => {
                          _sCfmz.show({
                            text: `この${pz.cz.tgt}を削除して良いですか？`,
                            ls: [
                              { key: 1, text: 'はい' },
                              { key: -1, text: 'いいえ' },
                            ],
                            onPrs: async ( _key: _ht.n ) => {
                              if ( _key == 1 ) {
                                if (pz.cz.onDltAsync) {
                                  const _b = await pz.cz.onDltAsync();
                                  if (_b != false) {
                                    pz.sPz.set({
                                      steps: [0],
                                      phs: 'd',
                                    });
                                  }
                                }
                              }
                            }
                          })
                        }
                      }            
                    },
                  }),

                ]
              }
              : undefined,
            ],
            pz.cz.atrClds
          )
        },
      ]
    })

  );
}